/**
 * Medidas del lienzo, en unidades del mundo (no en pixeles de pantalla).
 *
 * Estan aqui y no repartidas por el codigo porque la disposicion y el dibujo
 * tienen que estar de acuerdo: si el nodo mide una cosa al colocarlo y otra
 * al pintarlo, las etiquetas se pisan y las separaciones dejan de tener
 * sentido.
 */

/** Ancho de la tarjeta de una persona. */
export const ANCHO_NODO = 196;
/** Alto de la tarjeta. */
export const ALTO_NODO = 64;

/**
 * Como de cerca van dos personas contiguas de una misma fila, segun lo que
 * sean entre si.
 *
 * ESTO ES LO QUE HACE QUE EL DIAGRAMA SE LEA. Antes habia una sola separacion
 * para todos los pares, asi que al asentarse la fisica una pareja acababa
 * exactamente a la misma distancia que dos desconocidos, y toda una fila
 * parecia un unico grupo de hermanos. La distancia TIENE que decir algo:
 *
 *   pareja   muy juntas, casi tocandose: se leen como una unidad
 *   hermanos juntos pero despegados
 *   ajenos   un hueco ancho que separa de verdad una familia de otra
 */
export type Vecindad = "pareja" | "hermanos" | "ajenos";

const SEPARACIONES: Record<Vecindad, number> = {
  pareja: ANCHO_NODO + 16,
  hermanos: ANCHO_NODO + 62,
  ajenos: ANCHO_NODO + 190,
};

export function separacionMinima(v: Vecindad): number {
  return SEPARACIONES[v];
}

/** La mas pequena de todas, para los calculos que necesitan una cota. */
export const SEP_MINIMA_ABSOLUTA = SEPARACIONES.pareja;

/**
 * Distancia vertical entre una generacion y la siguiente.
 *
 * Es generosa a proposito. Un arbol de cuatro generaciones con treinta y
 * cinco personas en la mas poblada mide quince veces mas de ancho que de
 * alto, asi que al encuadrarlo entero las filas se aplastan contra el centro
 * y no se distingue una generacion de otra. Dar aire vertical cuesta poco
 * -- hay cuatro filas, no cuarenta -- y es lo que permite que la vista
 * general siga diciendo algo.
 */
export const ALTO_FILA = 430;

/** Radio de la esquina de la tarjeta de un hombre (forma rectangular). */
export const RADIO_HOMBRE = 6;
/** Radio de la de una mujer (forma redondeada). */
export const RADIO_MUJER = 32;

/**
 * A que altura va la barra horizontal de la que cuelgan los hermanos, medida
 * hacia arriba desde el borde superior de sus tarjetas.
 *
 * Es la barra de hermandad de los diagramas genealogicos de toda la vida: de
 * un vistazo dice "estos de aqui son hermanos entre si, e hijos de esa
 * pareja", que es justo lo que no se entendia antes.
 */
export const ALTURA_BARRA_HERMANOS = 54;

/** Radio de las esquinas de los conectores. Suaviza sin perder la lectura. */
export const RADIO_CODO = 12;
